import * as React from 'react';
import { Button, ButtonProps } from './button';
import styles from './button-inline.scss';

export const ButtonInline: React.FC<ButtonProps> = props => {
  const { children, className, ...rest } = props;

  return (
    <div>
      <Button btnType="" classNames={`standalone-link ${styles.buttonInline} ${className}`} {...rest}>
        {children}
      </Button>
    </div>
  );
};

ButtonInline.displayName = 'ButtonInline';
